import { TranslationsContext } from '@telia-common-components/shared';
import React, { useContext } from 'react';
import { Heading, Notice, Table, TableCell, TableRow, Text } from 'telia-front-react';
export const NetflixAppAdditionalInfo = () => {
    const { translate } = useContext(TranslationsContext);
    const additionalDetails = [
        {
            title: translate('netflixModal.info'),
            text: translate('netflixModal.info.text'),
        },
        {
            title: translate('netflixModal.language'),
            text: translate('netflixModal.language.text'),
        },
    ];
    return (React.createElement(Text, null,
        additionalDetails.map((section, sectionIndex) => (React.createElement(React.Fragment, { key: sectionIndex },
            React.createElement(Table, null,
                React.createElement("thead", null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { padding: "small", type: 'th' },
                            React.createElement(Heading, { level: 3, className: "h5" }, section.title)))),
                React.createElement("tbody", null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { padding: "small" }, section.text))))))),
        React.createElement(Notice, { size: "small" }, translate('netflixModal.notice.account'))));
};
